/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".loader-color[_ngcontent-%COMP%]{color:#fff;margin-left:100%}"];
export { styles as styles };
